import { render, staticRenderFns } from "./CircularProgress.vue?vue&type=template&id=32410c9b&"
import script from "./CircularProgress.vue?vue&type=script&lang=js&"
export * from "./CircularProgress.vue?vue&type=script&lang=js&"
import style0 from "./CircularProgress.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CircularProgress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCircularProgress});
